import { HttpClient, HttpErrorResponse, HttpParams, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs';
import { asignacion } from '../../entities/asignacion';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MsgConfigService {

  constructor(private http: HttpClient) { }

  registrarMensajeConfig(saveForm) {
    return this.http.post(environment.API_SECURITY + '/mensaje-sucursal', saveForm);
  }

  actualizarMensajeConfig(formData): Observable<any> {
		return this.http.put<any>(environment.API_SECURITY + '/mensaje-sucursal', formData);
	}

  obtenerMensajeConfig() {
		return this.http.get<any>(environment.API_SECURITY + '/mensaje-sucursal');
  }
}
